
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ActivityFormModal from "@/components/projects/activities/ActivityFormModal.vue";
  import { Project } from "@/interface";
  import { Project_Activity } from "@/generated/graphql";
  import UiButton from "@/components/button/ui-button.vue";
  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      UiButton,
      ActivityFormModal,
    },
  })
  export default class ProjectActivityAction extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserRole!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Object, required: true }) readonly project!: Project;
    @Prop({ type: Object, default: undefined }) readonly projectActivity?: Project_Activity;
    @Prop({ type: String, default: undefined }) readonly contractorId?: string;
    @Prop({ type: Boolean, default: false }) readonly redirectToDetails!: boolean;

    modalShown: boolean = false;

    get buttonText(): string {
      if (this.projectActivity) {
        return "Edit Task";
      }

      return "Add Task";
    }

    showModal(): void {
      this.modalShown = true;
    }

    hideModal(): void {
      this.modalShown = false;
    }

    onActivityAdded(): void {
      this.modalShown = false;

      this.$router.push({
        name: RouteNames.PROJECT_ACTIVITY,
        params: {
          id: this.project.id!,
        },
      });
    }
  }
